export default __webpack_public_path__ + "static/media/storageUnit1-afterD.535f13d0.jpg";